// @flow

import React from 'react';
import { Typography, Grid, Tabs, Tab } from '@material-ui/core/';
import TabPanel from '../../components/tabpanel';
import {
    SupportContainer,
    FAQ,
    Contact,
    ContactSupport,
} from '../../components/support';
import { type FAQCMS } from '../../data/cms/types/faq';
import FAQsContent from '../../data/cms/content/faqs';

//import { type ContactSupportCMS } from '../../data/cms/types/contact-support';

import './style.css';
type Props = {
    location: any,
};
function Support(props: Props) {
    const { location } = props;
    var page = location.state ? location.state.page : location ? location : 0;
    const [tabIndex, setTabIndex] = React.useState(parseInt(page));
    const [faqsContent, setFAQsContent] = React.useState<FAQCMS>({});
    const [loadingFAQ, setLoadingFAQ] = React.useState(true);
    /*const [
        contactContent,
        setContactContent
    ] = React.useState<ContactSupportCMS>({});
const [loadingContact, setLoadingContact] = React.useState(true);*/

    React.useEffect(() => {
        const fetchContent = async () => {
            const faqContent = await FAQsContent();
            setFAQsContent(faqContent);
            setLoadingFAQ(false);
            /* const contactContent = await ContactSupportContent();
            setContactContent(contactContent);
            setLoadingContact(false);*/
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, []);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    const onHandleTabChange = (e) => {
        if (e) e.preventDefault();
        setTabIndex(1);
    };

    return (
        <Grid container className="support">
            <Grid item sm={12} md={12} lg={12}>
                <SupportContainer>
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        className="support-tabs"
                    >
                        <Tab label="FAQs" />
                        {/*<Tab label="CONTACT SUPPORT" />*/}
                    </Tabs>
                    <TabPanel
                        value={tabIndex}
                        index={0}
                        className="support-faq"
                    >
                        {!loadingFAQ ? (
                            <Typography component="div">
                                <FAQ Content={faqsContent.FAQ.FAQs} />
                                <ContactSupport
                                    Content={faqsContent.FAQ.ContactSupport}
                                    onSupportClick={onHandleTabChange}
                                />
                            </Typography>
                        ) : null}
                    </TabPanel>
                    <TabPanel
                        value={tabIndex}
                        index={1}
                        className="support-contact"
                    >
                        <Contact />
                        {/* {!loadingContact ? (
                            <HelpCenter
                                Content={
                                    contactContent.ContactSupport.HelpCenter
                                }
                            />
                        ) : null}*/}
                    </TabPanel>
                </SupportContainer>
            </Grid>
        </Grid>
    );
}

export default Support;
